import { useContext, useState } from "react";
import { useAuthState } from "../../providers/AuthStateProvider";
import { BarbershopContext } from "../../providers/useProvider";
import { Outlet, NavLink, Link } from "react-router-dom";
import Logo from "../../assets/my-logo.png";
const Home = () => {
  const [openDropDown, setOpenDropDown] = useState(false);
  const { config, shopScheduleSetting, shopContactDetail } =
    useContext(BarbershopContext);
  const { user, logout } = useAuthState(); // Get user data from context
  const fullName = user?.fullName;
  const logoBaseUrl = process.env.REACT_APP_Image_APP_URL;
  const shortDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const numberToShortDay = (num) => {
    return shortDays[num] || "Invalid day";
  };
  if (!config) return null;
  return (
    <div className="full-page container-fluid">
      <div className="row header">
        <nav className="navbar navbar-expand-lg ">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">
              <img
                src={Logo}
                alt="Logo"
                className="d-inline-block align-text-top"
              />
            </a>
            <div className="collapse navbar-collapse d-inline-flex flex-fill d-flex justify-content-end">
              <ul className="navbar-nav   mb-lg-0">
                {!fullName && (
                  <Link
                    to="login"
                    className="btn btn-primary pr-2"
                    role="button"
                  >
                    Login
                  </Link>
                )}
                {fullName && (
                  <li className="nav-item dropdown   position-relative ms-auto">
                    <a
                      className="nav-link dropdown-toggle"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={() => setOpenDropDown(!openDropDown)}
                    >
                      <strong>{user.fullName}</strong>
                    </a>
                    <ul
                      className={` dropdown-menu ${openDropDown ? "show" : ""}`}
                    >
                      {/* <li>
                      <a className="dropdown-item" href="#">
                        Profile
                      </a>
                    </li> */}
                      <li>
                        <a className="dropdown-item" href={`/my-appointments`}>
                          Appointments
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href={`/`}>
                          New appointment
                        </a>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <a className="dropdown-item" onClick={logout}>
                          Logout
                        </a>
                      </li>
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </div>

      <div className="row main-page pt-5">
        <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <div className="card mb-3">
            <img
              src={`${logoBaseUrl}/images/logo/${shopContactDetail.logoUrl}`}
              className="card-img-top"
              alt="Barbershop Logo"
            />
            <div className="card-body">
              <h5 className="card-title">{config.brandName}</h5>
              <p className="card-text">{config.shortDescription}</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 mb-3 main-page">
          <Outlet />
        </div>

        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 p-2">
          <div className="card mb-3">
            <div className="card-body p-3">
              <h5 className="card-title">Opening Hours</h5>
              <ul
                className="list-unstyled"
                style={{ fontFamily: "monospace", whiteSpace: "pre" }}
              >
                {shopScheduleSetting?.map((d) => (
                  <li>
                    {numberToShortDay(d.day).padEnd(4)}:
                    {d.isClosed
                      ? "Closed"
                      : `${d.openTime
                          .split(":")
                          .slice(0, 2)
                          .join(":")} - ${d.closeTime
                          .split(":")
                          .slice(0, 2)
                          .join(":")}`}
                  </li>
                ))}
              </ul>
              <h5 className="card-title mt-3">Contact Info</h5>
              <p className="mb-1">{shopContactDetail.address}</p>
              <p className="mb-1">Phone: {shopContactDetail.phoneNumber}</p>
              <p>Email: {shopContactDetail.email}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <footer
          style={{
            textAlign: "center",
            padding: "15px 0",
            backgroundColor: "#f0f0f0",
            color: "#555",
            position: "fixed",
            bottom: 0,
            width: "100%",
          }}
        >
          © {new Date().getFullYear()} Kazaslot. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default Home;
